import { createMuiTheme } from "@material-ui/core/styles";
import { injectGlobal } from "styled-components";
// import purple from "@material-ui/core/colors/purple";

export const theme = createMuiTheme( {

    overrides: {
        MuiDialog: {
            paperWidthSm: {
                maxWidth: 800
            }
        },
        MuiFormControlLabel: {
            label: {
                lineHeight: 1.2
            }
        },
        MuiButton: {
            root: {
                borderRadius: 0
            },
            outlined : {
                border: "1px solid rgb(56,26,10)"
            }
        },
        MuiExpansionPanel: {
            root: {
                boxShadow: "none",
                borderBottom: "1px solid #381A0A",
                "&:last-child": {
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0
                },
                "&:hover": {
                    backgroundColor: "#F2F2F2"
                }
            },
            expanded: {                
               backgroundColor: "rgba(0,0,0,0.025)"
            }
        },
        MuiExpansionPanelActions: {
            root: {
                padding: 0
            },
            action: {
                marginRight: 16,
                marginLeft: 0,
            }            
        },
        MuiExpansionPanelDetails: {
            root: {
                borderTop: "1px solid rgba(0,0,0,0.15)"
            }
        },
        MuiExpansionPanelSummary: {
            root: {
                minHeight: 0,
                "&$expanded": {
                    minHeight: 0
                }
            },
            content: {
                margin: 0,
                "&$expanded": {
                    margin: 0
                }
            }
        },
        MuiMenu: {
            paper: {
                borderRadius: 0,
                borderTop: "2px solid #6E594E",
            }
        },
        MuiTableCell: {
            root: {
                paddingRight: 36
            }
        }
    },
    props: {
        MuiButtonBase: {
            disableRipple: false
        }        
    }, 
    typography: {
        fontFamily: ["Gotham", "Helvetica", "Arial", "sans-serif"].join(","),
        display1: {
            fontSize: 24,
            fontWeight: 300
        },
        display2: {
            fontSize: 24,
            fontWeight: 600,
            textTransform: "uppercase"
        },
        display3: {
            fontSize: 18,
            fontWeight: 300
        },
        title: {
            fontSize: 22,
            fontWeight: 600,
            letterSpacing: "0.02em"
        },
        headline: {
            fontSize: 18,
            fontWeight: 400
        },
        subheading: {
            fontSize: 14,
            fontWeight: 600,
        },
        body1: {
            fontSize: 12,
            fontWeight: 300,
            lineHeight: 1.8
        },
        body2: {
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.8
        },
        caption: {
            fontSize: 11,
            fontWeight: 300,
            letterSpacing: "0.025em"
        }
    },  
    palette: {
        text: {
            primary: "#381A0A",
            secondary: "#381A0A",
        },
        primary: {
            light: "#F2F2F2",
            main: "#381A0A",
            contrastText: "#FFFFFF"
        },
        secondary: {
            main: "#FFF078",
            dark: "#0052FF"
        }
    }
});

// tslint:disable
injectGlobal`
   body {
        margin: 0;
        font-family: "Gotham";
   }

   @font-face {
        font-family: "Gotham";
        src: url(${require("./fonts/Gotham-Light.eot")});
        font-weight: 300;
        font-style: normal;
   }

   @font-face {
        font-family: 'Gotham';
        src: url(${require('./fonts/Gotham-LightItalic.eot')});
        font-weight: 300;
        font-style: italic;
   }

   @font-face {
        font-family: 'Gotham'
        src: url(${require('./fonts/Gotham-Medium.eot')})
        font-weight: 400
        font-style: normal
   }

   @font-face {
        font-family: 'Gotham';
        src: url(${require('./fonts/Gotham-MediumItalic.eot')});
        font-weight: 400;
        font-style: italic;
    }

   @font-face {
       font-family: 'Gotham';
       src: url(${require('./fonts/Gotham-Bold.eot')});
       font-weight: 600;
       font-style: normal;
   }
`;


// WEBPACK FOOTER //
// ./src/theme/theme.ts